const calculationExampleDateLabelFormatter = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
});

export const buildCalculationExampleDateLabels = ({
  dayStep,
  endDayOffset = 0,
  today = new Date(),
}: {
  dayStep: number;
  endDayOffset?: number;
  today?: Date;
}): string[] => {
  const labelCount = 5;
  return Array.from({ length: labelCount }, (_unused, index) => {
    const labelDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    labelDate.setDate(today.getDate() - endDayOffset - (labelCount - index - 1) * dayStep);
    return calculationExampleDateLabelFormatter.format(labelDate);
  });
};

export const resolveCalculationExampleDateStep = ({
  blockColumnSpan = 1,
  segmentCount,
}: {
  blockColumnSpan?: number;
  segmentCount: number;
}): number => (blockColumnSpan > 1 || segmentCount <= 5 ? 1 : 2);

export const resolveCalculationExampleEndDayOffset = ({
  blockColumnSpan = 1,
  segmentCount,
}: {
  blockColumnSpan?: number;
  segmentCount: number;
}): number => (blockColumnSpan > 1 || segmentCount <= 5 ? 0 : 1);
